import { Component, OnInit,TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Cabinet_Interface, Empty_Cabinet_Interface } from 'src/app/Interface/Cabinet_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CabinetService } from 'src/app/Service/Cabinet/Cabinet.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-CabinetList',
  templateUrl: './CabinetList.component.html',
  styleUrls: ['./CabinetList.component.scss']
})
export class CabinetListComponent implements OnInit {
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private Cabinet_Service:CabinetService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Cabinet:Array<Cabinet_Interface>=[]
  Data_Seleted_Delete:Cabinet_Interface=Empty_Cabinet_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1153).subscribe(
      data=>{
        this.ReadData_Cabinet()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Cabinet(){
    this.Procssing=true
    this.Cabinet_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Cabinet=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:Cabinet_Interface){
    this.Procssing=true
    this.modalRef_Delete.hide()
    this.Cabinet_Service.DeleteCabinet(item.id).subscribe(
      data => {
        this.Procssing=false
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")
        this.ReadData_Cabinet()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  Switcher_Form: string = 'List'
  Set_Add_Switcher_Form() {
    this.Data_Seleted_Delete = Empty_Cabinet_Interface()
    this.Switcher_Form='Form'
  }

  Set_Edit_Switcher_Form(item:Cabinet_Interface) {
    this.Data_Seleted_Delete = item
    this.Switcher_Form='Form'
  }

  Set_Back_Switcher_Form() {
    this.Data_Seleted_Delete = Empty_Cabinet_Interface()
    this.Switcher_Form='List'
  }

}
